export const DEFAULT_NOTIFICATION_DURATION = 15000;
